import React, { useId } from 'react';
import { Button, Form } from 'react-bootstrap';
import CustomDatePicker from '../../_components/CustomDatePicker';
import { AUDIT_ACTION_LABELS, hasAuditFilters } from './planningAuditLog';

export default function PlanningAuditFilters({ filters, error, onChange, onClear }) {
    const filterId = useId();

    return (
        <div className="planning-audit__filters-block">
            <div className="planning-audit__filters" role="group" aria-label="Audit log filters">
                <div className="planning-audit__filter-field">
                    <CustomDatePicker
                        label="From"
                        controlId={`${filterId}-from`}
                        value={filters.from}
                        onChange={value => onChange({ from: value })}
                    />
                </div>
                <div className="planning-audit__filter-field">
                    <CustomDatePicker
                        label="To"
                        controlId={`${filterId}-to`}
                        value={filters.to}
                        onChange={value => onChange({ to: value })}
                    />
                </div>
                <div className="planning-audit__filter-field">
                    <Form.Label htmlFor={`${filterId}-action`}>Action</Form.Label>
                    <Form.Select
                        id={`${filterId}-action`}
                        value={filters.action}
                        onChange={event => onChange({ action: event.target.value })}
                    >
                        <option value="">All actions</option>
                        {Object.entries(AUDIT_ACTION_LABELS).map(([value, label]) => (
                            <option key={value} value={value}>{label}</option>
                        ))}
                    </Form.Select>
                </div>
                <div className="planning-audit__filter-field">
                    <Form.Label htmlFor={`${filterId}-job`}>Job No</Form.Label>
                    <Form.Control
                        id={`${filterId}-job`}
                        type="search"
                        placeholder="Any job no"
                        value={filters.jobNo}
                        onChange={event => onChange({ jobNo: event.target.value })}
                    />
                </div>
                <Button
                    className="planning-audit__clear"
                    variant="outline-secondary"
                    disabled={!hasAuditFilters(filters)}
                    onClick={onClear}
                >
                    Clear
                </Button>
            </div>
            {error && <div className="planning-audit__filter-error" role="alert">{error}</div>}
        </div>
    );
}
